module.exports = __webpack_public_path__ + "static/media/23.ed4cb35d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/23.mp3
// module id = 499
// module chunks = 0